import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import './index.scss';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import DownloadSVG from "./../../../../../Assets/icons/DownloadIconMIS.svg";
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import searchIcon from "../../../../../Assets/icons/searchicon.svg";
import Loader from '../../../../customComponents/CustomLoader';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import { FiDownload } from "react-icons/fi";


const MakeList = () => {
  const [makeData, setMakeData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [totalInactive, setTotalInactive] = useState(0)
  const [searchTerm, setSearchTerm] = useState('');


  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchMakeList(newPage);
  };

  const fetchMakeList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/make/list', {
        orderBy: 'make_id desc',
        page,
        pageSize,
        searchText: searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      const totalCount = response?.data?.data?.total
      const totalAct = response?.data?.data?.total_active
      const totalInac = response?.data?.data?.total_inactive

      setTotalData(totalCount)
      setTotalActive(totalAct)
      setTotalInactive(totalInac)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setMakeData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));

    } catch (error) {
      console.error('Error fetching make list:', error);
    }
    finally {
      setLoading(false)
    }
  };
  const MAKE_TABLE_HEADERS = [
    "Make Name",
    "Product Name",
    "Sub Product Name",

    "Description",
    "Status",
    "Action"
  ];

  const makeKeyMapping = {
    "Product Name": "product_name",
    "Sub Product Name": "subproduct_name",
    "Make Name": "make_name",
    "Description": "make_desc",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITMAKE}`, { state: { data: rowData } });
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchMakeList();
    }
  }, [searchTerm]);

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
      searchText: searchTerm,
      orderBy: "",
    };

    try {
      const response = await axiosInstance.post("/make/make-report-excel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "make.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };
  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className='OnboardManagamentContainer'>
            <div className='OnboardManagamentbuttonContainer'>
              <h5>Make Management</h5>
            </div>
            <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                <h5 className="listTopDataValueText" >{totalData} </h5>
                <h6>All Make</h6>
              </div>
              <div className='topleftdataContainer' style={{ borderRight: "1px solid lightgrey" }} >
                <h5 className="listTopDataValueText" >{totalActive} </h5>
                <h6>Active Make</h6>
              </div>
              <div className='topleftdataContainer'>
                <h5 className="listTopDataValueText" >{totalInactive} </h5>
                <h6>Inactive Make</h6>
              </div>
              <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-product/make/add-make')}>
                Add Make
              </button>
            </div>
          </div>
          <div className='tableWrapper'>
            <div className='admin-list-container'>
              <div className='listsearchContainer'>
                <h5>Make List</h5>
                <div>
                  <SearchInput
                    placeholder="Search Make"
                    onSearch={fetchMakeList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer" }}
                >
                  Export
                  <span>
                    {/* <img
                                    onClick={downloadExcel}
                                    src={DownloadSVG}
                                    alt="downloadSvg"
                                    className="downloadexcel-misreportsales"
                                    style={{
                                      // paddingTop: "9rem",
                                      // paddingRight: "1rem",
                                      
                                      cursor: "pointer",
                                      height:"24px"
                                    }}
                                  /> */}
                    <FiDownload className="downloadexcel-misreportsales" style={{ cursor: "pointer" }} size={22} />
                  </span>
                </div>

              </div>
            </div>
            <CustomTable
              data={makeData}
              headers={MAKE_TABLE_HEADERS}
              keyMapping={makeKeyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
            />
          </div>
        </div>

      )}
    </div>
  );
};

export default MakeList;
